<template>
    <h2 class="course-heading">Supplemental Material Finder</h2>
    <blockquote class="blockquote">
        <p>Complete the information below for one or more courses to view the required and recommended supplemental materials for
            your courses.
            Use information found to buy your materials for your classes.</p>
        <div><span class="bg-red">Note:</span> The course you are trying to view will not appear below if your instructor has not suggested any material yet.</div>
    </blockquote>
    <div className="card">
        <div class="card-header">
            <h5 class="card-title">Select your course(s)</h5>
        </div>
        <div className="card-body">
            <div class="table-responsive">
                <table class="table table-borderless">
                    <thead>
                        <tr>
                            <th scope="col" style="width:200px">Term</th>
                            <th scope="col">Department</th>
                            <th scope="col">Course #</th>
                            <th scope="col">Section</th>
                            <th scope="col" style="width:100px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in courseList" :key="index">
                            <td>
                                <select class="form-select" @change="onTermChange(index)" v-model="item.termId">
                                    <option value="null" disabled>Select Term</option>
                                    <option v-for="option in terms" :key="option.id"
                                        :value="option.id">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select class="form-select" :disabled="!item.termId" @change="onDepartmentChange(index)"
                                    v-model="item.departmentId">
                                    <option value="null" disabled>Select Department</option>
                                    <option v-for="option in item.departments" :key="option.id" :value="option.id">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select class="form-select" :disabled="!item.departmentId"
                                    @change="onCourseChange($event, index)" v-model="item.courseId">
                                    <option value="null" disabled>Select Course</option>
                                    <option v-for="option in item.courses" :key="option.id" :value="option.courseId">
                                         {{ option.sisCourseId }}       
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select class="form-select" :disabled="!item.courseId" @change="onChange($event)"
                                    v-model="item.sectionId">
                                    <option value="null" disabled>Select Section</option>

                                    <option v-for="option in item.sections" :key="option.id" :value="option.id">
                                       {{ option.sectionNumber }}
                                    </option>
                                </select>
                            </td>
                            <td class="align-middle">
                                <a class="cursor-pointer text-primary link" @click="resetCourseSelection(index)">
                                    <span class="material-icons">
                                        refresh
                                    </span>
                                    <a class="dis-t-c fw-bold text-primary link">
                                        Reset
                                    </a>
                                </a>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="col-sm-12">
                <button type="button" class="btn btn-outline-primary" @click="addCourseItem()">
                    <span class="material-icons-outlined btn-icon">
                        add_circle
                    </span>
                    Lookup Another Course
                </button>
                <button type="button" :disabled="!isFindMaterialEnabled" class="btn btn-primary float-end"
                    @click="goToMaterialsList()">
                    <span class="material-icons-outlined btn-icon">
                        search
                    </span>
                    Find Materials
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CourseFinder',
    data() {
        return {
            courseList: [],
            terms: []
        }
    },
    computed: {
        splitBy(value, seperator, position) {
            if (!value || value == "" || !value.includes("-")) {
                return value;
            }
            return value.split(seperator)[position];
        },
        isFindMaterialEnabled() {
            return this.courseList.some(x => x.sectionId != null);
        }
    },
    methods: {
        addCourseItem() {
            this.$store.dispatch('addCourseMaterial');
        },
        onTermChange(index) {
            this.getDepartments({ termId: this.courseList[index].termId, index: index });
            this.courseList[index].departmentId = null;
            this.courseList[index].courseId = null;
            this.courseList[index].sectionId = null;
        },
        onDepartmentChange(index) {
            this.courseList[index].courseId = null;
            this.courseList[index].sectionId = null;
            this.getCourses(this.courseList[index].departmentId, this.courseList[index].termId, index);

        },
        onCourseChange(event, index) {
            this.courseList[index].sectionId = null;
            this.getSections(event.target.value, index)
        },
        getCourses(departmentId, termId, index) {
            this.$store.dispatch('getCourses', { departmentId: departmentId, termId: termId, index: index });
        },
        getSections(courseId, index) {
            this.$store.dispatch('getSections', { id: courseId, index: index });
        },
        //To reset the fields
        resetCourseSelection(index) {
            this.courseList[index].termId = null;
            this.courseList[index].departmentId = null;
            this.courseList[index].courseId = null;
            this.courseList[index].sectionId = null;
        },
        onChange(event) {
            console.log(event, 'Event');
        },
        goToMaterialsList() {
            this.courseList = this.courseList.filter(x => x.sectionId);
            sessionStorage.clear();
            this.$router.push({ path: 'material-listing' })
        },
        getTerms() {
            this.$store.dispatch("getPresentAndFutureTerms").then((resp) => {
                this.terms = resp.data;
            });
        },
        getDepartments(termDetails) {
            this.$store.dispatch("getDepartments", termDetails);
        },
    


    },
    mounted() {
        this.getTerms();
        sessionStorage.clear();
        // if (sessionStorage.getItem('courseFinder')) {
        //     this.$store.state.student.courseFinder = JSON.parse(sessionStorage.getItem('courseFinder'));
        // }
        this.courseList = this.$store.state.student.courseFinder;
    }

}
</script>
<style scoped>
.card-title {
    margin-bottom: auto !important;
}
.bg-red {
    color: #ff1a1a;
    text-decoration: underline;
}

.link {
    text-decoration: none;
}
</style>